const SET_TAGS = "SET_TAGS";
const ADD_TAG = "ADD_TAG";
const UPDATE_TAG = "UPDATE_TAG";
const REMOVE_TAG = "REMOVE_TAG";

export { SET_TAGS, ADD_TAG, UPDATE_TAG, REMOVE_TAG };
